export const toIsoDate = (date: Date) => {
  const y = date.getUTCFullYear();
  const m = String(date.getUTCMonth() + 1).padStart(2, '0');
  const d = String(date.getUTCDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};

export const subtractDaysFromDate = (currentDate: Date, daysToSubtract = 0) => {
  const copy = new Date(currentDate);
  copy.setDate(copy.getDate() - daysToSubtract);
  return copy;
};

const startOfDayUTC = (d: Date) =>
  new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()));

export const endOfDayUTC = (d: Date) => {
  const x = new Date(d);
  x.setUTCHours(23, 59, 59, 999);
  return x;
};

const shiftDaysUTC = (d: Date, delta: number) => {
  const copy = new Date(d);
  copy.setUTCDate(copy.getUTCDate() + delta);
  return copy;
};

const shiftYearsUTC = (d: Date, deltaYears: number) => {
  const copy = new Date(d);
  copy.setUTCFullYear(copy.getUTCFullYear() + deltaYears);
  return copy;
};

export const parseDDMMYYYY = (s: string) => {
  const [dd, mm, yyyy] = s.split('.');

  return new Date(Date.UTC(Number(yyyy), Number(mm) - 1, Number(dd)));
};

export const getDateShortcuts = (end: Date) => {
  const e = startOfDayUTC(end);

  return {
    lastDay: {
      text: '1д',
      period: { start: shiftDaysUTC(e, -1), end: e },
    },
    last7Days: {
      text: '1н',
      period: { start: shiftDaysUTC(e, -7), end: e },
    },
    last30Days: {
      text: '1м',
      period: { start: shiftDaysUTC(e, -30), end: e },
    },
    last90Days: {
      text: '3м',
      period: { start: shiftDaysUTC(e, -90), end: e },
    },
    last180Days: {
      text: '6м',
      period: { start: shiftDaysUTC(e, -180), end: e },
    },
    last270Days: {
      text: '9м',
      period: { start: shiftDaysUTC(e, -270), end: e },
    },
    last365Days: {
      text: '1г',
      period: { start: shiftYearsUTC(e, -1), end: e },
    },
    last2Years: {
      text: '2г',
      period: { start: shiftYearsUTC(e, -2), end: e },
    },
    last3Years: {
      text: '3г',
      period: { start: shiftYearsUTC(e, -3), end: e },
    },
  };
};

export const firstDateOfMonth = (date = new Date()) =>
  new Date(date.getFullYear(), date.getMonth(), 1);

export const getDatesBetweenDates = (startDate: Date, endDate: Date) => {
  const dates: Date[] = [];
  const cur = new Date(startDate);
  while (cur <= endDate) {
    dates.push(new Date(cur));
    cur.setDate(cur.getDate() + 1);
  }
  return dates;
};

export function daysUntilEndOfYear() {
  const date = new Date();
  const y = date.getUTCFullYear();
  const startOfDayUTC = Date.UTC(y, date.getUTCMonth(), date.getUTCDate());
  const startOfNextYearUTC = Date.UTC(y + 1, 0, 1);
  const MS_PER_DAY = 24 * 60 * 60 * 1000;
  return Math.floor((startOfNextYearUTC - startOfDayUTC) / MS_PER_DAY);
}

export function daysUntilEndOfMonth() {
  const date = new Date();
  const y = date.getUTCFullYear();
  const m = date.getUTCMonth();
  const startOfDayUTC = Date.UTC(y, m, date.getUTCDate());
  const startOfNextMonthUTC = Date.UTC(y, m + 1, 1);
  const MS_PER_DAY = 24 * 60 * 60 * 1000;
  return Math.floor((startOfNextMonthUTC - startOfDayUTC) / MS_PER_DAY);
}

export function daysUntilEndOfQuarter() {
  const date = new Date();
  const y = date.getUTCFullYear();
  const m = date.getUTCMonth();
  const currentQuarter = Math.floor(m / 3) + 1;

  // Определяем последний месяц квартала и последний день
  const lastMonthOfQuarter = currentQuarter * 3 - 1; // 2, 5, 8, 11 (март, июнь, сентябрь, декабрь)
  const lastDayOfQuarter = new Date(y, lastMonthOfQuarter + 1, 0).getDate(); // 0 день следующего месяца = последний день текущего

  const startOfDayUTC = Date.UTC(y, m, date.getUTCDate());
  const endOfQuarterUTC = Date.UTC(y, lastMonthOfQuarter, lastDayOfQuarter, 23, 59, 59, 999);
  const MS_PER_DAY = 24 * 60 * 60 * 1000;
  return Math.floor((endOfQuarterUTC - startOfDayUTC) / MS_PER_DAY) + 1;
}

export const isEqualTwoDates = (a: Date, b: Date) => a.getTime() === b.getTime();

export const yearStartDate = (year: number) => {
  return new Date(year, 0, 1, 0, 0, 0, 0);
};

export const yearEndDate = (year: number) => {
  return new Date(new Date(year + 1, 0, 1) - 1);
};

export const sleep = (ms: number) => new Promise(r => setTimeout(r, ms));
